"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Statsig_1 = __importDefault(require("./Statsig"));
var StatsigContext_1 = __importDefault(require("./StatsigContext"));
function default_1(users) {
    var initStarted = (0, react_1.useContext)(StatsigContext_1.default).initStarted;
    (0, react_1.useEffect)(function () {
        if (!initStarted || users.length == 0) {
            return;
        }
        Statsig_1.default.prefetchUsers(users).catch(function () {
            // noop
        });
    }, [initStarted, users]);
}
exports.default = default_1;
